import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { ITenant, defaultValue } from 'app/shared/model/tenant.model';

export const ACTION_TYPES = {
  FETCH_TENANT_LIST: 'tenant/FETCH_TENANT_LIST',
  FETCH_TENANT: 'tenant/FETCH_TENANT',
  CREATE_TENANT: 'tenant/CREATE_TENANT',
  UPDATE_TENANT: 'tenant/UPDATE_TENANT',
  DELETE_TENANT: 'tenant/DELETE_TENANT',
  RESET: 'tenant/RESET',
  UPLOAD_FILE: 'tenant/UPLOAD_FILE',
  UPLOAD_FILE_DONE: 'tenant/UPLOAD_FILE_DONE',
  VERIFY_DEVICE: 'tenant/VERIFY_DEVICE',
  PURGE_DEVICE: 'tenant/PURGE_DEVICE',
  RESET_DEVICE: 'tenant/RESET_DEVICE'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ITenant>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
  savedResponse: {
    savedDevices: null,
    alreadyImported: null,
    failedDevices: null,
    alreadyRegistered: null
  }
};

export type TenantState = Readonly<typeof initialState>;

// Reducer

export default (state: TenantState = initialState, action): TenantState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_TENANT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_TENANT):
    case REQUEST(ACTION_TYPES.UPLOAD_FILE_DONE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_TENANT):
    case REQUEST(ACTION_TYPES.UPDATE_TENANT):
    case REQUEST(ACTION_TYPES.DELETE_TENANT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_TENANT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_TENANT):
    case FAILURE(ACTION_TYPES.CREATE_TENANT):
    case FAILURE(ACTION_TYPES.UPDATE_TENANT):
    case FAILURE(ACTION_TYPES.DELETE_TENANT):
    case FAILURE(ACTION_TYPES.VERIFY_DEVICE):
    case FAILURE(ACTION_TYPES.UPLOAD_FILE):
    case FAILURE(ACTION_TYPES.UPLOAD_FILE_DONE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_TENANT_LIST):
      return {
        ...state,
        loading: false,
        totalItems: action.payload.headers['x-total-count'],
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_TENANT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_TENANT):
    case SUCCESS(ACTION_TYPES.UPDATE_TENANT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_TENANT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case SUCCESS(ACTION_TYPES.VERIFY_DEVICE):
    case SUCCESS(ACTION_TYPES.PURGE_DEVICE):
    case SUCCESS(ACTION_TYPES.RESET_DEVICE):
    case SUCCESS(ACTION_TYPES.UPLOAD_FILE):
      return {
        ...state,
        updating: false,
        updateSuccess: true
      };
    case ACTION_TYPES.UPLOAD_FILE_DONE:
      return {
        ...state,
        savedResponse: action.payload
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/tenants';

// Actions

export const getEntities: ICrudGetAllAction<ITenant> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_TENANT_LIST,
    payload: axios.get<ITenant>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`)
  };
};

export const getTenants: ICrudGetAllAction<ITenant> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_TENANT_LIST,
    payload: axios.get<ITenant>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`)
  };
};

export const getEntity: ICrudGetAction<ITenant> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_TENANT,
    payload: axios.get<ITenant>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<ITenant> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_TENANT,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<ITenant> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_TENANT,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<ITenant> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_TENANT,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});

export const uploadFile = file => async dispatch => {
  const formFile = new FormData();
  formFile.set('file', file);
  const postResult = await axios.post('api/v1/devices/import', formFile);
  await dispatch({
    type: ACTION_TYPES.UPLOAD_FILE_DONE,
    payload: postResult.data
  });

  const result = await dispatch({
    type: ACTION_TYPES.UPLOAD_FILE,
    payload: postResult
  });
  return result;
};

export const verifyDevice = deviceName => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.VERIFY_DEVICE,
    payload: axios.post('api/v1/devices/verify', null, { params: { deviceId: deviceName } })
  });
  return result;
};

export const purgeDevice = deviceName => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.VERIFY_DEVICE,
    payload: axios.post('api/v1/devices/purge', [], { params: { deviceId: deviceName, removeFromDB: true } })
  });
  return result;
};

export const resetDevice = deviceName => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.VERIFY_DEVICE,
    payload: axios.post('api/v1/devices/purge', [], { params: { deviceId: deviceName, removeFromDB: false } })
  });
  return result;
};
